// extracted by mini-css-extract-plugin
export default {"colorIcon":"_3NHdT CO6xt","emojiIcon":"V_e0c rTQr-","icon":"_2JDh8 _2rmlO"};